<template>
  <ExportDynamicTable
    :tableData="getSelectedNavigationTableData"
    :tableDataIdentifier="tableDataIdentifier"
    :tableName="tableName"
    :tableColumns="tableColumns"
    :projectId="projectId"
    :template="template"
    :language="language"
    :isValidRequest="isValidRequest"
    :selectedRowKeys="getSelectedNavigationSelectedRows"
    :navigationSelectedItem="navigationSelectedItem"
    @tableContentUpdated="setMeasurementPointTableContent"/>
</template>

<script>
import ExportDynamicTable from '@/components/export/tables/exportDynamicTable'
import GuiTemplateParser from '@/components/dynamicTables/GuiTemplateParser'
import Cookie from '@/utils/cacheProviders/cookieCacheProvider'
import stringUtils from '@/utils/stringUtils'
import Popup from '@/utils/popup'
import Config from '@/configurations/config'

const TiPopup = Popup[Config.platform].default

export default {
  name: 'MeasurementPointsExportTable',
  components: {
    ExportDynamicTable
  },
  props: {
    projectId: {
      type: String,
      required: true
    },
    tableDataPerSampleType: {
      type: Array,
      required: true
    },
    navigationSelectedItem: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      isLoading: false,
      tableColumns: [],
      template: {},
      tableDataIdentifier: 'MpGuid',
      tableName: 'tblMeasurementPoints',
      templateName: 'frmMeasurementPointsGrid',
      excludedDataFieldKeys: ['MpName', 'MpTypeCode', 'MpXCoord', 'MpYCoord', 'MpDate', 'SlID']
    }
  },
  async created() {
    this.$emit('isLoading', true)
    await this.getMeasurementPointTableColumns()
    this.$emit('isLoading', false)
  },
  computed: {
    isValidRequest() {
      return this.isProjectIdSet
    },
    isProjectIdSet() {
      return stringUtils.isNullOrEmptyOrWhitespace(this.projectId) === false
    },
    language() {
      return Cookie.get('language')
    },
    getSelectedNavigationTableData() {
      return this.getMeasurementPointTableData().tableData
    },
    getSelectedNavigationSelectedRows() {
      return this.getMeasurementPointTableData().selectedRows
    }
  },
  methods: {
    getMeasurementPointTableData() {
      return this.tableDataPerSampleType.find(item => item.name === this.navigationSelectedItem)
    },
    async getMeasurementPointTableColumns() {
      try {
        const [templateData, sublocations] = await Promise.all([
          this.$store.dispatch('getDefaultFieldTemplate', {
            templateName: this.templateName
          }),
          this.$store.dispatch('getSubLocations', {
            projectId: this.projectId
          })
        ])

        const parsedTemplate = GuiTemplateParser.parseTemplate(templateData, { sublocations })
        if (!parsedTemplate) return

        parsedTemplate.forEach((column) => {
          if (!this.excludedDataFieldKeys.includes(column.dataFieldKey)) {
            column.visible = false
          }
        })

        const mpDateColumn = parsedTemplate.find((tableColumn) => tableColumn.dataFieldKey === 'MpDate')
        if (mpDateColumn) {
          mpDateColumn.dataType = 'date'
        }

        this.template = templateData
        this.tableColumns = parsedTemplate
      } catch (error) {
        await this.handleErrorResponse(error)
      }
    },
    setMeasurementPointTableContent(measurementPointTableContent) {
      this.$emit('tableContentUpdated', measurementPointTableContent)
    },
    async handleErrorResponse(error, errorMessage = 'message.UnknownError') {
      console.error(error)
      TiPopup.popup(this.$t(errorMessage))
    }
  }
}
</script>
